import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, Crown } from "lucide-react";
import { useCart } from "@/context/CartContext";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/shop", label: "Shop" },
  { to: "/books", label: "Books" },
  { to: "/resources", label: "Resources" },
  { to: "/about", label: "About" },
];

export default function Nav() {
  const { count, setOpen } = useCart();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/80 border-b border-slate-200/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-[72px]">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5 group">
          <span className="w-9 h-9 rounded-xl bg-[#3B1F6E] flex items-center justify-center">
            <Crown className="w-5 h-5 text-[#D97706]" />
          </span>
          <span className="font-serif-display text-2xl font-semibold tracking-tight text-[#2E1065]">QRU Online</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) => `text-sm font-semibold tracking-wide transition-colors ${isActive ? "text-[#3B1F6E]" : "text-slate-600 hover:text-[#3B1F6E]"}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <button data-testid="cart-button" onClick={() => setOpen(true)} className="relative p-2.5 rounded-full hover:bg-slate-100 transition-colors">
          <ShoppingBag className="w-5 h-5 text-[#2E1065]" />
          {count > 0 && (
            <span data-testid="cart-count" className="absolute -top-0.5 -right-0.5 bg-[#D97706] text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">{count}</span>
          )}
        </button>
      </div>
    </header>
  );
}
